import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './SingleTradeForm.css';
import Dropdown from 'components/shared/dropdown/Dropdown';
import MultipleDropdown from 'components/shared/dropdown/MultipleDropdown';
import TextareaAutosize from 'react-autosize-textarea';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import LabeledCheckBox from 'components/shared/checkbox/LabeledCheckBox';
import uploadSvg from 'images/upload.svg';
import removeIconPng from 'images/remove.png';
import Dropzone from 'react-dropzone';
import DocumentLink from 'components/shared/document/DocumentLink';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import { imageExtensions } from 'services/utils/files-util';
import { Project } from 'domain/project';
import { getDirectory } from 'components/admin/projects/details/project-directory/store/selectors';

class ProjectOpenItemForm extends Component {
  static propTypes = {
    form: PropTypes.shape({}).isRequired,
    errors: PropTypes.shape({}).isRequired,
    handleAttributeChange: PropTypes.func.isRequired,
  };

  recipientOptions = () => {
    return Project.recipientOptions(this.props);
  };

  assigneeOptions = () => {
    return this.recipientOptions().map((opt) => {
      return { value: opt.id, label: opt.label };
    });
  };

  setImages = (files) => {
    let images = [...this.getImages()];
    files.forEach(function (val) {
      images.push({
        url: URL.createObjectURL(val),
        file: val,
      });
    });

    const { handleAttributeChange } = this.props;
    handleAttributeChange('openItemImages', images);
  };

  removeImage = (index) => {
    let images = [...this.getImages()];
    let deletedImages = [...this.getDeletedImages()];
    let deletedImage = images.splice(index, 1);
    deletedImages.push(deletedImage[0]);

    const { handleAttributeChange } = this.props;
    handleAttributeChange('openItemImages', images);
    handleAttributeChange('openItemDeletedImages', deletedImages);
  };

  getImages = () => {
    const { form } = this.props;
    if (form && form.openItemImages && form.openItemImages.length > 0) {
      return form.openItemImages;
    }
    return [];
  };

  getDeletedImages = () => {
    const { form } = this.props;
    if (
      form &&
      form.openItemDeletedImages &&
      form.openItemDeletedImages.length > 0
    ) {
      return form.openItemDeletedImages;
    }
    return [];
  };

  setDocuments = (files) => {
    let docs = [...this.getDocuments()];
    files.forEach(function (val) {
      docs.push({
        file: val,
        name: val.name,
      });
    });

    const { handleAttributeChange } = this.props;
    handleAttributeChange('openItemDocuments', docs);
  };

  removeDocument = (index) => {
    let docs = [...this.getDocuments()];
    let deletedDocs = [...this.getDeletedDocuments()];
    let deletedDoc = docs.splice(index, 1);
    deletedDocs.push(deletedDoc[0]);

    const { handleAttributeChange } = this.props;
    handleAttributeChange('openItemDocuments', docs);
    handleAttributeChange('openItemDeletedDocuments', deletedDocs);
  };

  getDocuments = () => {
    const { form } = this.props;
    if (form && form.openItemDocuments && form.openItemDocuments.length > 0) {
      return form.openItemDocuments;
    }
    return [];
  };

  getDeletedDocuments = () => {
    const { form } = this.props;
    if (
      form &&
      form.openItemDeletedDocuments &&
      form.openItemDeletedDocuments.length > 0
    ) {
      return form.openItemDeletedDocuments;
    }
    return [];
  };

  render() {
    const { form, errors, handleAttributeChange } = this.props;
    return (
      <div className="project-open-item-form">
        <div className="single-trade-form-block assignee-block">
          <label className="single-trade-form-label">Assigned To</label>
          <Dropdown
            className={classnames({
              'single-trade-form-error-field': errors.openItemAssigneeId,
            })}
            placeholder="Select Assignee..."
            onChange={(option) =>
              handleAttributeChange('openItemAssigneeId', option.value)
            }
            value={form.openItemAssigneeId}
            options={this.assigneeOptions()}
          />
        </div>
        <div className="single-trade-form-block recipients-block">
          <label className="single-trade-form-label">CC Recipient(s)</label>
          <MultipleDropdown
            options={this.recipientOptions()}
            currentValues={form.openItemRecipients || []}
            placeholder="Select Contributors to CC"
            onChange={(values) =>
              handleAttributeChange('openItemRecipients', values)
            }
          />
        </div>
        <div className="single-trade-form-block resolve-by-block">
          <label className="single-trade-form-label">Due Date</label>
          <div
            className={classnames({
              'single-trade-form-error-field': errors.openItemResolveBy,
            })}
          >
            <DatetimePicker
              isValidDate={todayValidation}
              placeholder="Resolve By"
              onChange={(value) =>
                handleAttributeChange('openItemResolveBy', value)
              }
              value={form.openItemResolveBy}
            />
          </div>
        </div>
        <div className="single-trade-form-block">
          <label className="single-trade-form-label">Description</label>
          <TextareaAutosize
            rows={2}
            className={classnames({
              'text-area': true,
              'input-area': true,
              'form-control': true,
              'single-trade-form-error-field': errors.openItemDesc,
            })}
            onBlur={(e) =>
              handleAttributeChange('openItemDesc', e.target.value)
            }
            defaultValue={form.openItemDesc}
          />
        </div>
        <div className="single-trade-form-block">
          <label className="single-trade-form-label">Mark as Critical</label>
          <LabeledCheckBox
            onChange={handleAttributeChange.bind(null, 'openItemCritical')}
            checked={form.openItemCritical}
          />
        </div>
        <div className="single-trade-form-block single-trade-form-block-docs">
          {form.openItemDocuments &&
            form.openItemDocuments.map((doc, index) => {
              return (
                <div className="doc-viewer" key={index}>
                  <img
                    className="remove-doc-icon"
                    src={removeIconPng}
                    alt="remove"
                    onClick={() => this.removeDocument(index)}
                  />
                  <DocumentLink file={doc} url={doc.url} />
                </div>
              );
            })}
          <Dropzone
            accept="application/pdf, .doc, .docx, .xls, .xlsx"
            className="dropzone-container"
            onDrop={(files) => this.setDocuments(files)}
          >
            <span>Please drag and drop any file into this area</span>
            <img src={uploadSvg} alt="upload" />
          </Dropzone>
        </div>
        <div className="single-trade-form-block">
          <ImageUpload
            extensions={imageExtensions}
            multiple
            onUpload={(files) => this.setImages(files)}
            onRemove={(index) => this.removeImage(index)}
            images={this.getImages()}
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    directory: getDirectory(state),
  };
})(ProjectOpenItemForm);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/ProjectOpenItemForm.js